/**
 * Swatch del canale v4 (N10, `Centro Ticket v4.dc.html` L93, L296, L639):
 * quadratino col colore deterministico del canale (`channelPalette`, Q6); con
 * `sigla` diventa la tessera 30×30 con la sigla mono in bianco (AA garantito
 * dalla palette). Decorativo per default: accanto c'e sempre il nome del
 * canale; con `labelled` porta il proprio nome accessibile.
 *
 * Con l'avatar del canale (emoji o immagine) rende quello al posto del
 * quadratino/sigla, senza bordo (2026-10-27). Lato minimo 14 px:
 * sotto un'emoji non si legge. Senza avatar il DOM resta quello di sempre.
 */
import React from 'react';
import { channelTone, type ChannelLike } from './channelPalette';
import { resolveChannelAvatar } from '../channelAvatar';

const AVATAR_MIN_PX = 14;

export interface ChannelSwatchProps {
  channel?: ChannelLike | null;
  /** Lato in px (8 in tabella, 30 per la tessera con sigla). */
  size?: number;
  sigla?: boolean;
  labelled?: boolean;
}

const ChannelSwatch: React.FC<ChannelSwatchProps> = ({ channel, size = 8, sigla = false, labelled = false }) => {
  const tone = channelTone(channel);
  const a11y = labelled
    ? { role: 'img' as const, 'aria-label': `Canale ${channel?.nome || 'senza nome'}` }
    : { 'aria-hidden': true as const };
  const av = resolveChannelAvatar(channel?.avatar);
  if (av) {
    const px = Math.max(size, AVATAR_MIN_PX);
    return (
      <span
        className={`s4-sw s4-sw--av${sigla ? ' s4-sw--sigla' : ''}`}
        style={{ ['--s4-sw' as string]: `${px}px`, ['--s4-sw-bg' as string]: `var(${tone.cssVar})` } as React.CSSProperties}
        data-tone={String(tone.key)}
        data-avatar={av.kind}
        {...a11y}
      >
        {av.kind === 'emoji' ? (
          <span className="s4-sw__emo" style={{ fontSize: `${Math.round(px * 0.66)}px` }}>{av.emoji}</span>
        ) : (
          <img className="s4-sw__img" src={av.src} alt="" />
        )}
      </span>
    );
  }
  return (
    <span
      className={`s4-sw${sigla ? ' s4-sw--sigla' : ''}`}
      style={{ ['--s4-sw' as string]: `${size}px`, ['--s4-sw-bg' as string]: `var(${tone.cssVar})` } as React.CSSProperties}
      data-tone={String(tone.key)}
      {...a11y}
    >
      {sigla ? tone.sigla : null}
    </span>
  );
};

export default ChannelSwatch;
